import Lib from '../../../commons/lib';

export default class Service {

  static jegyVasarlasUrl = window.location.origin + '/api/jegyvasarlas/';


  static helyszinUrl = window.location.origin + '/api/helyszin/';


  // HELYSZÍN START

  static getSzin(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'public/szin',
      params: { id: id },
      args: { requestType: 'helyszin-szin' },
    }], fnDone);
  }

  // HELYSZÍN END

  // JEGY START

  static getEvent(azon, fizetesiModAzonositok, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      public: true,
      url: Service.jegyVasarlasUrl + 'public/event/' + azon,
      data: fizetesiModAzonositok
    }], fnDone);
  }

  static sendPurchase(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      public: true,
      url: Service.jegyVasarlasUrl + 'public/event/purchase',
      data: data
    }], fnDone);
  }

  static deleteEvent(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      public: true,
      url: Service.jegyVasarlasUrl + 'public/event/timeout',
      params: {
        id: id,
      }
    }], fnDone);
  }

  static checkNyugtaBizonylatAndLimit(rid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      public: true,
      url: Service.jegyVasarlasUrl + 'public/event/check/szamlazas',
      params: {
        id: rid
      }
    }], fnDone);
  }

  // JEGY END

  // BARION START

  static GetPaymentState(PaymentId, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: 'https://api.test.barion.com/v2/Payment/GetPaymentState',
      params: {
        "POSKey": "b4da76c2a1724b92a032bf00680ff316",
        "PaymentId": PaymentId,
    }
    }], fnDone);
  }

  static paymentStart(url, data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: 'https://api.test.barion.com/v2/Payment/Start',
      data: {
        "POSKey": "b4da76c2a1724b92a032bf00680ff316",
        "PaymentType": "Immediate",
        "PaymentRequestId": "EXMPLSHOP-PM-001",
        "FundingSources": ["All"],
        "GuestCheckOut": true,
        "Currency": "HUF",
        "PayerHint": "vevo@mukodj.hu",
        "RedirectUrl": url,
        "Transactions": [
            {
                "POSTransactionId": "EXMPLSHOP-PM-001/TR001",
                "Payee": "gergely.nagy.contact@gmail.com",
                "Total": 5000,
                "Comment": "A brief description of the transaction",
                "Items": [
                    {
                        "Name": "MOZIJEGY-John Wick 3 - 3D",
                        "Description": "3ds mozijegy",
                        "Quantity": 1,
                        "Unit": "darab",
                        "UnitPrice": 2000,
                        "ItemTotal": 4000,
                        "SKU": "EXMPLSHOP/SKU/PHC-01"
                    },
                    {
                        "Name": "MOZIJEGY-John Wick 3 - 3D KEDVEZMÉNY",
                        "Description": "3ds mozijegy",
                        "Quantity": 2,
                        "Unit": "darab",
                        "UnitPrice": 1500,
                        "ItemTotal": 3000,
                        "SKU": "EXMPLSHOP/SKU/PHC-01"
                    }
                ]
            }
        ]
    }
    }], fnDone);
  }

  // BARION END
}
